import { render, staticRenderFns } from "./ProductBarEcharts.vue?vue&type=template&id=5df79472"
import script from "./ProductBarEcharts.vue?vue&type=script&lang=js"
export * from "./ProductBarEcharts.vue?vue&type=script&lang=js"
import style0 from "./ProductBarEcharts.vue?vue&type=style&index=0&id=5df79472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports